<i
  *ngIf="!customIcon"
  class="fa-solid fa-circle-info icon-popover"
  [style.color]="iconColor ? iconColor : 'lightslategray'"
  [popoverClass]="'content'"
  triggers="mouseenter:mouseleave"
  [ngbPopover]="popContent"
  [placement]="placement"
></i>

<span
  *ngIf="customIcon"
  class="icon-popover"
  [style.color]="iconColor ? iconColor : 'lightslategray'"
  [popoverClass]="'content'"
  triggers="mouseenter:mouseleave"
  [ngbPopover]="popContent"
  [placement]="placement"
>
  <span [innerHTML]="customIcon"></span>
</span>

<ng-template #popContent>{{ key | translate }}<span *ngIf="value">{{ value | number:'1.2-2' }}</span>
</ng-template>
